



























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { SavedSearch } from '@/interfaces/SavedSearch';
import { eventBus, eventBusEvents } from '@/helpers/eventBusHelper';
import { formatDateWithMonthName } from '@/helpers/dateFormatter';

@Component({
    name: 'ViewSearchDialog',
})

export default class ViewSearchDialog extends Vue {
    protected currentRow: null | { id: number } = null;
    protected isListLoading = false;
    protected showHeader = true;
    protected idsBeingWorked: number[] = [];
    @Prop({
        required: true,
    }) protected isSaveSearchDialogVisible!: boolean;
    @Action('search/getSavedSearches') protected getSavedSearches!: () => Promise<unknown>;
    @Action('search/deleteSavedSearch') protected deleteSavedSearch!: (id: number) => Promise<unknown>;
    @Action('search/downloadSavedSearch') protected downloadSavedSearch!: (id: number) => Promise<string>;
    @Action('search/getSavedSearch') protected getSavedSearch!: (id: number) => Promise<string>;

    protected get savedSearches() {
        return this.$store.getters['search/savedSearches'];
    }

    protected checklist = [{
        date: '27 September 2019',
        title: 'Search_test123',
        id: 1,
    },
        {
            date: '27 May 2019',
            title: 'Search_test123',
            id: 2,
        }, {
            date: '27 April 2019',
            title: 'test2_this is a long name that will go into two rows',
            id: 3,
        }, {
            date: '27 March 2019',
            title: 'Search_test123',
            id: 4,
        },
        {
            date: '27 February 2019',
            title: 'Search_test123',
            id: 5,
        }, {
            date: '27 January 2019',
            title: 'Search_test123',
            id: 6,
        }];

    protected closeDialog() {
        this.$emit('closeDialog', 'view');
    }

    protected get isValid() {
        return this.currentRow !== null;
    }

    protected async onLoadSearch() {
        if (this.currentRow) {
            eventBus.$emit(eventBusEvents.activateGlobalLoading);
            this.$emit('closeDialog', 'view');
            if (this.$route.name !== 'SearchResults') {
                this.$router.push({name: 'SearchResults'}, async () => {
                    if (this.currentRow == null) {
                        return;
                    }

                    await this.getSavedSearch(this.currentRow.id);
                    eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
                });
            } else {
                await this.getSavedSearch(this.currentRow.id);
                eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            }
        }

    }

    protected async onCommand(id: number) {
        if (id) {
            const savedSearch = this.savedSearches.filter((search: SavedSearch) => id === search.id);
            if (!savedSearch.length) {
                this.$message.error('There was an error, please try again.');
                return;
            }
            this.idsBeingWorked.push(id);
            try {
                await this.deleteSavedSearch(id);
            } catch (e) {
                this.$message.error('There was an error, please try again.');
            } finally {
                this.idsBeingWorked.splice(this.idsBeingWorked.indexOf(id), 1);
            }
        }
    }

    protected formatDate(date: string) {
        return formatDateWithMonthName(date);
    }

    protected handleCurrentChange(row: { id: number }) {
        this.currentRow = row;
    }

    protected async onDownload(el: any) {
        this.$message.info('Generating Excel, please wait.');
        const savedSearch = this.savedSearches.filter((search: SavedSearch) => el.id === search.id);
        if (!savedSearch.length) {
            this.$message.error('There was an error, please try again.');
            return;
        }
        this.idsBeingWorked.push(el.id);
        const blob = await this.decodeCSV(el.id);
        const name = `Markables_SearchDoc_` + el.name + `_` + this.formatDate(el.createdAt) + `.xlsx`;
        this.fileSaver(blob, name);
        this.idsBeingWorked.splice(this.idsBeingWorked.indexOf(el.id), 1);
    }

    protected async decodeCSV(id: number) {
        const invoice = await this.downloadSavedSearch(id);
        const byteCharacters = atob(invoice);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], {type: 'application/csv'});
    }

    protected fileSaver(blob: Blob, name: string) {
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, name);
            return;
        } else if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, name);
            return;
        }
        link.href = data;
        link.download = name;
        document.body.appendChild(link);
        link.click();
    }

    protected async mounted() {
        this.isListLoading = true;
        try {
            await this.getSavedSearches();
        } catch (e) {
            this.$message.error('There was an error fetching the saved searches');
        } finally {
            this.isListLoading = false;
        }
    }
}
